var _desc, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowsTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M16 3.33325L24 14.6666L8 14.6666L16 3.33325ZM24 26.6666L16 15.3333L8 26.6666L24 26.6666ZM16 7.95996L13.1466 11.9999L18.8534 11.9999L16 7.95996ZM16 19.96L13.1466 23.9999L18.8534 23.9999L16 19.96Z",
    fill: "#151319",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowsTop);
export default __webpack_public_path__ + "static/media/ic_arrows_top.c7814b535a770b97878633228c9f858a.svg";
export { ForwardRef as ReactComponent };